// extracted by mini-css-extract-plugin
export default {"userAdditionalInfo":"AdditionalUserInfo__userAdditionalInfo--1uc","separator":"AdditionalUserInfo__separator--30m"};